import React from 'react';
import { Box } from '@saviynt/design-system';

import IntegrationsHeader from '../../features/Integrations/components/IntegrationsHeader/IntegrationsHeader';
import IntegrationsPageAllTab from '../../features/Integrations/components/IntegrationsPageAllTab/IntegrationsPageAllTab';

// import TopActionBar from '../../features/Integrations/components/TopActionBar/TopActionBar';
// import DiscoveryCardTable from '../../features/Integrations/components/DiscoveryCardTable/DiscoveryCardTable';
import './IntegrationsDashboard.css';

/**
 * Integrations Landing page
 */
function IntegrationsDashboard() {
  // const [categorySelection, setCategorySelection] = useState('2');
  return (
    <Box className='Integrations'>
      <IntegrationsHeader />

      <div className='IntegrationsPageToolbox-wrapper'>
        <div className='IntegrationsPageToolbox-mainContent'>
          {/* <TopActionBar
            setCategorySelection={setCategorySelection}
            categorySelection={categorySelection}
          /> */}
          {/* <DiscoveryCardTable /> */}
          {/* {categorySelection === '2' && <DiscoveryCardTable />}
          {categorySelection === '1' && <IntegrationsPageAllTab />} */}
          <IntegrationsPageAllTab />
        </div>

        {/* {isSidePanelOpen && selectedIntegration && (
          <SideDetailPanel
            integration={selectedIntegration}
            onClose={() => setSidePanelOpen(false)}
          />
        )} */}
      </div>
    </Box>
  );
}

export default IntegrationsDashboard;
